import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../apiConfig";
import CSRFToken from "../cookies.js";
import Employee from "../image/Employee.png";
import Spinner from "../image/spinner.svg";
import Navbar from "../Component/navbar.jsx";
import Footer from "../Component/footer.jsx";
import { saveAs } from "file-saver";

import {
  BsCloudCheckFill,
  BsCloudUpload,
  BsExclamationTriangleFill,
} from "react-icons/bs";
import { useDispatch } from "react-redux";
import TYPE from "../reducer/Type.js";
import { toast } from "react-toastify";

function Payments() {
  const [cur_plan_name, setCurrPlanName] = useState(null);
  const [cur_plan_date, setCurrPlanDate] = useState(null);
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const [plans, setPlans] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState(null);
  const [loader, setLoader] = useState(false);
  const [subStatus, setSubStatus] = useState(null);
  const [deactivatePopup, setDeactivatePop] = useState(false);
  const [completedFlag, setCompletedFlag] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState("");
  const dispatch = useDispatch();
  const fetchPlans = async () => {
    try {
      const authToken = localStorage.getItem("access");
      const response = await fetch(`${API_URL}/pricing`, {
        method: "POST",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        const filteredPlans = data.plans.filter(
          (plan) => !plan.is_subscribed && plan.plan_type === "Pro"
        );
        setPlans(filteredPlans);
      } else {
        console.error("Failed to fetch plans", response.status);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchUserSubs = async () => {
    try {
      setLoader(true);
      const authToken = localStorage.getItem("access");
      const response = await fetch(`${API_URL}/user_subscriptions`, {
        method: "GET",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        // console.log(data)
        if (data.length > 0) {
          const subscriptionsCharged = [];

          data.forEach((sub) => {
            setSubStatus(sub.status.toUpperCase());
            if (sub?.status === 'active') {
              setSubscriptionId(sub?.subscription_id);
            }
            if (sub.total_count !== sub.paid_count) {
              setCompletedFlag(true);
            }
            const chargedDetail = sub.razorpay_details.find(
              (detail) => detail.event_type === "subscription.charged"
            );
            setCurrPlanName(sub.product_name);
            if (chargedDetail && chargedDetail.invoiceURL) {
              setCurrPlanDate(
                new Date(chargedDetail.current_end).toLocaleDateString()
              );
              subscriptionsCharged.push({
                productName: sub.product_name,
                subscriptionChargedDate: new Date(
                  chargedDetail.event_timestamp
                ).toLocaleDateString(),
                amount: chargedDetail.amount,
                invoiceURL: chargedDetail.invoiceURL,
                charge_at: chargedDetail.charge_at,
              });
            }
          });

          setSubscriptionDetails(subscriptionsCharged);
        } else {
          console.error("No subscriptions found for the user");
        }
      } else {
        console.error("Failed to fetch user subscriptions", response.status);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleCheckboxChange = (invoiceURL) => {
    setSelectedInvoices(invoiceURL === selectedInvoices ? null : invoiceURL);
  };

  //   const downloadInvoices = async () => {
  //     const zip = new JSZip();

  //     const fetchFile = async (url) => {
  //       const response = await fetch(url);
  //       if (!response.ok) throw new Error(`Could not fetch file: ${url}`);
  //       const blob = await response.blob();
  //       return blob;
  //     };

  //     try {
  //       await Promise.all(selectedInvoices.map(async (url, index) => {
  //         const blob = await fetchFile(url);
  //         const filename = url.split('/').pop();
  //         zip.file(filename, blob);
  //       }));

  //       const content = await zip.generateAsync({ type: 'blob' });
  //       saveAs(content, 'invoices.zip');
  //     } catch (error) {
  //       console.error('Error downloading files:', error);
  //     }
  //   };

  const downloadInvoices = async () => {
    const link = document.createElement("a");
    link.href = selectedInvoices;
    link.setAttribute("download", selectedInvoices.split("/").pop()); // Extract file name from URL
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDpop = () => {
    setDeactivatePop(true);
  };

  const handleStaySubscribed = () => {
    setDeactivatePop(false);
  };

  const fetchUserProfile = async () => {
    try {
      const authToken = localStorage.getItem("access");

      const response = await fetch(`${API_URL}/fetch-user-profile`, {
        method: "GET",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = await response.json();

      dispatch({
        type: TYPE.GET_USER_SUCCESS,
        payload: {
          user: data,
        },
      });
      return;
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelSubscription = async () => {
    try {
      // subscription_id
      // cancel-subscription

      if (!subscriptionDetails) {
        toast.error("Active plan not found", {
          autoClose: 1500,
        });
        return;
      }

      setLoader(true);
      const authToken = localStorage.getItem("access");
      const response = await fetch(`${API_URL}/cancel-subscription`, {
        method: "POST",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          subscription_id: subscriptionId,
        }),
      });
      setLoader(false)
      if (response.ok) {
        toast.success("Your active plan is deactivated successfully.", {
          autoClose: 1500,
        });
      } else {
        toast.error("Something went wrong please try again later.", {
          autoClose: 1500,
        });
      }
      return;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  useEffect(() => {
    fetchUserSubs();
    fetchPlans();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <div className="flex flex-col min-h-screen px-4 py-8">
        {loader && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-10">
            <img
              loading="lazy"
              src={Spinner}
              alt="spinner"
              class="w-12 h-12 animate-spin max-md:w-6 max-md:h-6"
            />
          </div>
        )}
        {deactivatePopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
            <div className="flex flex-col w-[380px] h-[380px] rounded-2xl bg-white">
              <h6 className="px-4 pt-3 text-xs font-semibold text-orange-500">
                CANCEL SUBSCRIPTION
              </h6>
              <p className="px-4 pt-2 text-2xl font-bold">
                You’re about to cancel your subscription
              </p>
              <p className="px-4 pt-2 font-semibold text-gray-500">
                After cancelling your hirebeen subscription your premium
                benefits will continue until the subscription end date.
              </p>
              <hr className="mx-4 my-6 text-gray-500" />
              <ul className="mr-4 text-sm">
                <li className="mb-2">Subscription end date is 24/01/2024</li>
                <li className="mr-2">
                  You will not be billed after your subscription end date
                </li>
              </ul>
              <div className="flex mx-4 my-3">
                <input type="checkbox" className="mr-1 mt-[2px]" />I confirm I
                want to cancel my subscription.
              </div>
              <div className="flex gap-2 mx-4">
                <button
                  className="px-4 py-2 text-sm font-semibold rounded-md flex-3 h-fit border-1"
                  onClick={handleStaySubscribed}
                >
                  Stay Subscribed
                </button>
                <button
                  onClick={handleCancelSubscription}
                  className="flex-1 py-2 text-sm font-semibold text-white bg-orange-500 rounded-md h-fit border-1"
                >
                  Yes, Cancel Subscription
                </button>
              </div>
            </div>
          </div>
        )}
        {completedFlag && (
          <h6 className="text-center ">
            YOUR CURRENT{" "}
            <span className="font-semibold text-teal-800">{cur_plan_name}</span>{" "}
            SUBSCRIPTON IS{" "}
            <span className="font-semibold text-teal-800">{subStatus}</span>{" "}
            TILL{" "}
            <span className="text-base font-semibold text-teal-800">
              {cur_plan_date}
            </span>
            <p className="text-sm font-medium text-center text-gray-500">
              Your will be next charged on {subscriptionDetails.charge_at}
            </p>
          </h6>
        )}
        {!completedFlag && subStatus !== "CREATED" && (
          <h6 className="text-center ">
            YOUR CURRENT{" "}
            <span className="font-semibold text-teal-800">{cur_plan_name}</span>{" "}
            SUBSCRIPTON IS{" "}
            <span className="font-semibold text-teal-800">{subStatus}</span>{" "}
            TILL{" "}
            <span className="text-base font-semibold text-teal-800">
              {cur_plan_date}
            </span>
          </h6>
        )}

        <div className="flex flex-wrap justify-center gap-4 mt-6">
          {plans.map((plan, index) => (
            <div className="relative z-10 flex flex-col px-6 py-4 bg-white shadow-lg w-fit rounded-2xl">
              <div className="flex items-center gap-2 pb-2">
                <img
                  src="https://hirebeen.com/image/hlogonew.svg"
                  className="w-8 h-8"
                  alt=""
                />
                <p className="text-base font-semibold">{plan.plan_name} Plan</p>
              </div>
              <hr />
              <div className="flex-auto">
                <ul className="pt-2 pl-0 ml-5 text-sm text-gray-800">
                  {JSON.parse(plan.plan_description).map((feature, index) => (
                    <li>{feature}</li>
                  ))}
                </ul>
              </div>
              <div className="flex-none">
                <hr className="my-2" />
                <div className="flex items-center justify-between">
                  <p className="text-xl font-semibold">
                    ₹{plan.plan_price}
                    <span className="text-lg">/mon</span>
                  </p>
                  <button className="p-2 text-xs font-semibold text-white bg-orange-500 rounded-lg">
                    UPGRADE
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-between mx-48 mt-10 mb-4">
          <p className="text-lg font-bold">Payment History</p>
          <button
            onClick={downloadInvoices}
            className="flex flex-wrap items-center gap-1 px-2 py-1 text-base font-semibold border-gray-900 rounded-lg border-1"
          >
            <svg
              fill="none"
              strokeWidth="2"
              xmlns="http://www.w3.org/2000/svg"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
              height="1em"
              width="1em"
            >
              <path d="M8 17 12 21 16 17"></path>
              <path d="M12 12 12 21"></path>
              <path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>
            </svg>
            Download
          </button>
        </div>
        <div className="flex justify-between mx-48">
          <table className="min-w-full overflow-hidden bg-white rounded-lg shadow-md">
            <thead className="bg-gray-200">
              <tr>
                <th className="w-10 px-4 py-1 text-left">
                  <input type="checkbox" className="w-4 h-4 form-checkbox" />
                </th>
                <th className="flex flex-wrap items-center px-4 py-2 text-left">
                  <svg
                    fill="currentColor"
                    strokeWidth="0"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1024 1024"
                    height="1em"
                    width="1em"
                  >
                    <path d="M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"></path>
                  </svg>
                  Invoice
                </th>
                <th className="w-24 px-2 py-1 text-left">Amount</th>
                <th className="w-32 px-2 py-1 text-left">Date</th>
                <th className="w-24 px-2 py-1 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {subscriptionDetails.map((subscription, index) => (
                <tr className="border-t" key={index}>
                  <td className="px-4 py-2 text-gray-500">
                    <input
                      type="checkbox"
                      className="w-4 h-4 form-checkbox"
                      checked={subscription.invoiceURL === selectedInvoices}
                      onChange={() =>
                        handleCheckboxChange(subscription.invoiceURL)
                      }
                    />
                  </td>
                  <td className="px-4 py-2 text-sm font-semibold">
                    {subscription.productName}
                  </td>
                  <td className="px-2 py-2 text-sm font-semibold text-gray-500">
                    ₹{subscription.amount}
                  </td>
                  <td className="px-2 py-2 text-sm font-semibold text-gray-500">
                    {subscription.subscriptionChargedDate}
                  </td>
                  <td className="px-2 py-2">
                    <span className="flex flex-wrap items-center gap-1 py-1 pl-2 pr-3 text-xs font-semibold text-green-800 bg-green-200 rounded-full w-fit">
                      <svg
                        fill="currentColor"
                        strokeWidth="0"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        height="1em"
                        width="1em"
                      >
                        <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path>
                      </svg>
                      Paid
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {completedFlag && (
        <p className="text-sm text-center">
          Do you want to cancel current active plan?{" "}
          <a onClick={handleDpop} className="underline cursor-pointer">
            Deactivate
          </a>
        </p>
      )}
      <Footer />
    </div>
  );
}

export default Payments;
